const validate = values => {
	const errors = {}
	if (!values.state_id) {
		errors.state_id = 'Este campo es obligatorio'
	}
	if (!values.pry_form_locality) {
		errors.pry_form_locality = 'Este campo es obligatorio'
	}
	if (!values.pry_zip_code) {
		errors.pry_zip_code = 'Este campo es obligatorio'
	}
	if (!values.pry_address_street) {
		errors.pry_address_street = 'Este campo es obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsPryAddressForm.js
 **/